import { z } from 'zod';

import {
  CopilotDataContextObjectSchema,
  DocumentTranscriptionResponsesSchema,
} from './submitPriorAuthorization.js';

export const HumanTaskParsedClinicalQuestionAssistantConfigSchema = z.object({
  dataContext: CopilotDataContextObjectSchema,
});
export type HumanTaskParsedClinicalQuestionAssistantConfig = z.infer<
  typeof HumanTaskParsedClinicalQuestionAssistantConfigSchema
>;

export const HumanTaskParsedDocumentPacketGeneratorConfigSchema = z.object({
  relevantDocuments: DocumentTranscriptionResponsesSchema,
});

export const HumanTaskParsedToolsSchema = z
  .object({
    enabledTools: z.array(z.string()).optional(),
    config: z
      .object({
        clinicalQuestionAssistant: HumanTaskParsedClinicalQuestionAssistantConfigSchema.optional(),
        documentPacketGenerator: HumanTaskParsedDocumentPacketGeneratorConfigSchema.optional(),
      })
      .optional(),
  })
  .optional();
export type HumanTaskParsedTools = z.infer<typeof HumanTaskParsedToolsSchema>;
